import { render } from "./AddNewUserModal.vue?vue&type=template&id=6469abde&ts=true"
import script from "./AddNewUserModal.vue?vue&type=script&lang=ts"
export * from "./AddNewUserModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__